import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const access_token = "admin-token";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(access_token) || "",
    userRoles: [],
    userPermissions: [],
    userInfo: {},
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem(access_token, token);
    },
    clearToken(state) {
      state.token = "";
      localStorage.removeItem(access_token);
    },
    //清空vuex里面所有内容
    clearVuex(state) {
      state.userInfo = {};
      state.userPermissions = [];
      state.userRoles = [];
      // state.editableTabsValue = "/home";
      // state.editableTabs = [
      //     {
      //         title: "首页",
      //         path: "/home"
      //     }
      // ];
    },
    //设置用户信息
    setUserInfo(state, obj) {
      state.userInfo = obj;
    },
    //设置按钮权限信息
    setUserPermissions(state, list) {
      state.userPermissions = list;
    },
    //设置角色信息
    setUserRoles(state, list) {
      state.userRoles = list;
    },
  },
  actions: {
    logout({ commit }) {
      commit("clearToken");
    },
    //退出时执行清空所有vuex里面的内容
    clearAllVuex({ commit }) {
      commit("clearVuex");
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
});
